import { render, staticRenderFns } from "./ComoFunciona.vue?vue&type=template&id=fdf476c2&"
import script from "./ComoFunciona.vue?vue&type=script&lang=js&"
export * from "./ComoFunciona.vue?vue&type=script&lang=js&"
import style0 from "./ComoFunciona.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports